export default "__VITE_ASSET__a8706cf6__"